import React from 'react'

import OrangeButton from '../../../../components/Buttons/OrangeButton'

const StorageCard = ({ service }) => {
  const handleChangeConnection = () => {
    service.connected ? handleDisconnect() : handleIntegrate()
  }

  const handleIntegrate = () => {}

  const handleDisconnect = () => {}

  return (
    <div className="w-[248px] p-[24px] flex items-center justify-center flex-col rounded-[10px] border-[1px] border-[#FFCA84] ">
      <img src={service.icon} alt={service.name} className="w-[100px] h-[100px]" />

      <div className="text-base text-primary-100 font-bold mt-4">{service.name}</div>

      <OrangeButton
        text={service.connected ? 'Disconnect' : 'Integrate'}
        etcClass="!w-full"
        className="mt-[24px] w-full"
        onClick={handleChangeConnection}
      />
    </div>
  )
}

export default StorageCard
